import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { WebChannelDeliveryMethodDto } from './WebChannelDeliveryMethodDto'
import { WebChannelPaymentMethodDto } from './WebChannelPaymentMethodDto'
/**
* Class WebChannelOrdersConfig
*  Публичные настройки заказов веб-витрины
*/
export class WebChannelOrdersConfig extends ActiveModel {

  /**
  * allowAnonymousOrders
  * Разрешить оформление заказов анонимными пользователями<br>  */
  @ActiveField(false)
  allowAnonymousOrders: boolean = false


/**
  * draftTtl
  * Время, в течение которого можно приступить к оплате заказа, с момента его последнего изменения <br><br>Время, после которого система отменяет заказ<br>
  */
  @ActiveField('')
  draftTtl: string = ''


/**
  * paymentUrlTtl
  * Время, в течении которого действительна ссылка для оплаты<br>
  */
  @ActiveField('')
  paymentUrlTtl: string = ''


/**
  * @property deliveryMethods
  * Эффективные способы доставки (Enabled; Cdek — только при credentials Seller)<br>  */
  @ActiveField({
    factory: [WebChannelDeliveryMethodDto, () => []]
  })
  deliveryMethods: Array<WebChannelDeliveryMethodDto> = []


/**
  * @property paymentMethods
  * Эффективные способы оплаты (Enabled; способы через шлюз — только при включённом подключении продавца).<br>Покупатель выбирает один из них при оформлении; выбор проверяется на сервере.<br>  */
  @ActiveField({
    factory: [WebChannelPaymentMethodDto, () => []]
  })
  paymentMethods: Array<WebChannelPaymentMethodDto> = []
}
